// extracted by mini-css-extract-plugin
module.exports = {"link":"_3TNen","menuItemWrapper":"fU0Tq","twoColumnsWrapper":"_8qsBi","mobileOnly":"_2ZAvL","arrow":"Rt1K1","linkWrapper":"_164t0","active":"_1X7M3","withSubMenu":"_8ela9"};